module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-SemiBoldItalic.ecc12ec.woff";